import type { IAccount } from '@/types/login'
import mrRequest from '@/utils/request'

/* 用户登录 */
export function fetchLogin(account: IAccount) {
  return mrRequest.post({
    url: '/login',
    data: account
  })
}

/* 获取用户详情 */
export function fetchUserInfo(id: number) {
  return mrRequest.get({
    url: `/users/${id}`
  })
}

/* 获取角色菜单树 */
export function fetchRoleMenus(id: number) {
  return mrRequest.get({
    url: `/role/${id}/menu`
  })
}
